import axios, { AxiosInstance } from "axios";
import { setupSecureInterceptors } from "./tokenManager";
import { getRequestScopeHeaders } from "./requestScope";

export const createNewInstance = (BASE_URL: string): AxiosInstance => {
  const instance = axios.create({
    baseURL: BASE_URL,
    headers: getRequestScopeHeaders(),
  });
  return setupSecureInterceptors(instance);
};

export const rag_v2 = createNewInstance(window.env.REACT_APP_RAG_API_URL_V2);
export const rag_v1 = createNewInstance(window.env.REACT_APP_RAG_API_URL);

export const uploadDocument = async (conversationId: string, file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await rag_v2.post(
    `/conversations/${conversationId}/documents`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        ...getRequestScopeHeaders(),
      },
    }
  );
  return response.data;
};

export const getDocuments = async (conversationId: string) => {
  const response = await rag_v2.get(`/conversations/${conversationId}/documents`);
  return response.data;
};

export const deleteDocument = async (conversationId: string, documentId: string) => {
  const response = await rag_v2.delete(`/conversations/${conversationId}/documents/${documentId}`);
  return response.data;
}
